import { render, staticRenderFns } from "./HtmlEmailComposer.vue?vue&type=template&id=2fe63668"
import script from "./HtmlEmailComposer.vue?vue&type=script&lang=js"
export * from "./HtmlEmailComposer.vue?vue&type=script&lang=js"
import style0 from "./HtmlEmailComposer.vue?vue&type=style&index=0&id=2fe63668&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports